import cn from 'classnames/bind';
import { UserAvatar } from 'ui';
import { findByType } from 'utils/personalities';

import s from './DrawerUserInfo.module.css';

const cx = cn.bind(s);

const DrawerUserInfo = ({
  children, className, user, ...attrs
}) => (
  <div className={cx(className, 'wrapper')} {...attrs}>
    <div className={cx('avatar')}>
      <UserAvatar type={user.type} gender={user.gender} tone={user.skinTone} />
    </div>
    <div className={cx('info')}>
      <div className={cx('name')}>
        { user.name }
      </div>
      <div className={cx('status')}>
        { findByType(user.type)?.title }
      </div>
    </div>
  </div>
);

export default DrawerUserInfo;
